<template>
	<div :style="shu.yangshi" class="zidingyi_Zijin box_show">
		<div v-for="l in shu.shu" class="zidingyi_zijinlie">
			<div class="zidingyi_shu ziti12px" :style="yangshi">{{l.shuliang}}</div>
			<div class="zidingyi_name ziti12px" :style="yangshis">{{l.ming}}</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'zijin',
		data() {
			return {
				zijinlie: [{
					ming: "余额",
					shuliang: "5666"
				}, {
					ming: "优惠券",
					shuliang: "4"
				}, {
					ming: "积分",
					shuliang: "124541"
				}],
				yangshi:'',
				yangshis:''
			}
		},
		props: {
			shu: {
				type: Object,
				default () {
					return {
						wenzi: '输入文字',
						yangshi: {}
					}
				}
			}
		},
		
		created() {
			if (!this.shu.shu) {
				this.$set(this.shu, 'shu', this.zijinlie)
			}
			if (!this.shu.yangshi) {
				this.$set(this.shu, 'yangshi', {})
			}
			if (!this.shu.yangshis) {
				this.$set(this.shu, 'yangshis', {})
			}
		},
	watch: {
			'shu.yangshi.font_size': function() {
				this.Ys();
			},
			'shu.yangshi.color': function() {
				this.Ys();
			},
			'shu.yangshi.font_weight': function() {
				this.Ys();
			},
			// 
			'shu.yangshis.font_size': function() {
				this.Yss();
			},
			'shu.yangshis.color': function() {
				this.Yss();
			},
			'shu.yangshis.font_weight': function() {
				this.Yss();
			}
		},
		methods: {
			Ys() {
				this.yangshi = "";
				var px = '';
				if (this.shu.yangshi.font_size) {
					px=(this.shu.yangshi.font_size>0)?(this.shu.yangshi.font_size+'px'):this.shu.yangshi.font_size;		
					this.yangshi += "font-size:" + px+ ";";
				}
				if (this.shu.yangshi.color) {
					this.yangshi += "color:" + this.shu.yangshi.color+ ";";
				}
				if (this.shu.yangshi.font_weight) {
					this.yangshi += "font-weight:" + this.shu.yangshi.font_weight+ ";";
				}
				console.log(this.yangshi)
			},
			Yss() {
				this.yangshis = "";
				var px = '';
				if (this.shu.yangshis.font_size) {
					px=(this.shu.yangshis.font_size>0)?(this.shu.yangshis.font_size+'px'):this.shu.yangshis.font_size;		
					this.yangshis += "font-size:" + px+ ";";
				}
				if (this.shu.yangshis.font_weight) {
					this.yangshis += "font-weight:" + this.shu.yangshis.font_weight+ ";";
				}
				if (this.shu.yangshis.color) {
					this.yangshis += "color:" + this.shu.yangshis.color+ ";";
				}
				console.log(this.yangshis)
			}
		}
	}
</script>
